import {atomWithImmer} from "jotai-immer";
import {ApprovalStatus, ZyusetuFragmentFragment, ZyusetuType} from "@/graphql/graphql.ts";

export const DEFAULT_ZYUSETU_FRAGMENT: ZyusetuFragmentFragment = {
  approvalStatus: ApprovalStatus.Draft,
  createdAt: undefined,
  files: [],
  id: "",
  realEstateBrokers: [],
  realEstateTransactionSpecialists: [],
  template: {
    id: "",
    title: "",
    requiredFileTypes: [],
    optionalFileTypes: [],
    sections: [],
    type: ZyusetuType.Rent
  }
}

export const ZyusetuAtom = atomWithImmer<ZyusetuFragmentFragment>(DEFAULT_ZYUSETU_FRAGMENT);

